import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export const PrivateRoute = ({ children, rolesPermitidos = [] }) => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Cargando...</div>;
  }

  // Si no hay usuario logueado
  if (!auth || !auth.id) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si se definen rolesPermitidos y el usuario no tiene uno de ellos
  if (rolesPermitidos.length > 0 && !rolesPermitidos.includes(auth.rol)) {
    return (
      <div className="acceso-denegado">
        <h2>Acceso denegado</h2>
        <p>No tienes permisos para ver esta sección.</p>
      </div>
    );
  }

  // Usuario autorizado: renderiza los children (componente protegido)
  return children;
};
